<template>
  <div id="examine_vue">
    <!-- 表格列表 -->
    <el-table
      ref="multipleTable"
      :data="resultData"
      border
      tooltip-effect="dark"
      style="width: 100%"
      @cell-click="cellClick">
      <el-table-column
        prop="adTitle"
        :label="$t('advert.name')">
      </el-table-column>
      <el-table-column
        prop="type"
        :label="$t('advert.classify')"
        width="150">
        <template slot-scope="scope">
          <span v-for="item in adTypeList" v-if="item.adtypeId === scope.row.adType">{{item.adtypeName}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="index"
        :label="$t('advert.position')" width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.adPosition == 0">首页banner</span>
          <span v-if="scope.row.adPosition == 1">启动界面</span>
          <span v-if="scope.row.adPosition == 3">{{$t('app_appadv')}}</span>
          <span v-if="scope.row.adPosition == 2">个人中心banner</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="adStartEnd"
        :label="$t('advert.ableDate')"
        :formatter="dateFormat"
        width="120">
      </el-table-column>
      <el-table-column
        prop="adCreateUsername"
        :label="$t('advert.addUser')"
        width="120">
      </el-table-column>
      <el-table-column
        prop="adCreateTime"
        :label="$t('advert.addDate')" width="180">
        :formatter="dateFormat"
      </el-table-column>
    </el-table>
    <div style="margin-top: 20px">
    </div>
    <!-- 表格列表 END-->

    <!-- 分页 -->
    <paging :rdata="pagingData" :action="pAction"></paging>
    <!-- 分页 END -->



    <el-dialog :title="$t('menu.advertManageSub.examine')" :visible.sync="dialogFormVisible">
      <el-form label-position="right" label-width="80px">
        <el-form-item :label="$t('advert.name')" >
          <span class="grey_color">{{editorForm.adTitle}}</span>
        </el-form-item>
        <el-form-item :label="$t('advert.classify')">
          <!--<span class="grey_color">{{editorForm}}</span>-->
          <span class="grey_color" v-for="item in adTypeList" v-if="item.adtypeId === editorForm.adType">{{item.adtypeName}}</span>
        </el-form-item>
        <el-form-item :label="$t('advert.position')">
          <template>
            <span class="grey_color" v-if="editorForm.adPosition == 0">{{$t('advert.positionSub.banner')}}</span>
            <span class="grey_color" v-if="editorForm.adPosition == 1">{{$t('advert.positionSub.starPage')}}</span>
            <!--<span class="grey_color" v-if="editorForm.adPosition == 2">个人中心banner</span>-->
          </template>
        </el-form-item>

        <el-form-item :label="$t('advert.jumpType')">
          <span class="grey_color" v-if="editorForm.adUrltype == '0'">{{$t('advert.jumpTypeSub.net')}}</span>
          <span class="grey_color" v-if="editorForm.adUrltype == '1'">{{$t('advert.jumpTypeSub.appStore')}}</span>
        </el-form-item>

        <el-form-item v-if="editorForm.adUrltype === '1'" :label="$t('advert.app')" prop="ad_url">
          <span class="grey_color" >{{editorForm.application.appName}}</span>
        </el-form-item>

        <!-- 当跳转类型为跳转时,ad_url则输入跳转的url -->
        <el-form-item v-if="editorForm.adUrltype === '0'" :label="$t('advert.url')">
          <span class="grey_color" >{{editorForm.adUrl}}</span>
        </el-form-item>

        <!--<el-form-item label="跳转链接">-->
          <!--<span class="grey_color">{{editorForm.adUrl}}</span>-->
        <!--</el-form-item>-->
        <el-form-item :label="$t('advert.ableDate')">
          <span class="grey_color">{{dateFormat2(editorForm.adStartEnd)}}</span>
        </el-form-item>
        <el-form-item :label="$t('advert.contentImg')">
          <!--<span class="grey_color">{{editorForm.adTitle}}</span>-->
          <img :src="imageUrl + editorForm.adImgurl" width="100%" height="auto" />
        </el-form-item>

        <el-form-item :label="$t('advert.isPass')" prop="resource">
          <el-radio-group v-model="isAble">
            <el-radio label="1">{{$t('advert.pass')}}</el-radio>
            <el-radio label="0">{{$t('advert.notPass')}}</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item v-if="isAble === '0'" :label="$t('advert.refusal')">
          <el-input v-model="refuse_reason"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button @click="dialogFormVisible = false">{{$t('mao_global.btn.cancel')}}</el-button>
          <el-button type="primary" @click="sbIsAble">{{$t('mao_global.btn.ok')}}</el-button>
        </el-form-item>
      </el-form>
      <!--<el-form>-->
        <!--<el-form-item label="活动名称" label-width="150">-->
          <!--<el-input  auto-complete="off"></el-input>-->
        <!--</el-form-item>-->
      <!--</el-form>-->
      <!--<div slot="footer" class="dialog-footer">-->
        <!--<el-button @click="dialogFormVisible = false">取 消</el-button>-->
        <!--<el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>-->
      <!--</div>-->
    </el-dialog>

  </div>

</template>
<style scoped>
  .grey_color {
    color:grey;
  }
</style>
<script>
  import axios from 'axios'
  import mm from 'moment'
  import { baseurl,url } from '../../api/url'
  import MPage from '@/components/global/paging.vue'
  import jq from 'jquery'
  export default{
    components: {
      paging: MPage
    },
    data () {
    	var that = this
      return {
    		// 是否通过   1 通过   0拒绝
        isAble: '1',
        // 拒绝理由
        refuse_reason: '',
        imageUrl: url,
        pagingData: {
          total: 0,
          pageSize: 10,
          currentPage: 1
        },
        pAction : {
          handleSizeChange (v) {
            that.filterParam['rows'] = v;
            that.filterParam['page'] = 1;
            that.fetchData()
          },
          handleCurrentChange (v) {
            that.filterParam['page'] = v;
            that.fetchData()
          }
        },
        dialogFormVisible: false,
        adTypeList: null,
        resultData: null,
        sbForm: {
          ad_id: null,
          ad_status: null,
          refuse_reason: null,
          token: null
        },
        editorForm: {},
        tableData: [
//          {
//            title: '奶茶广告',
//            type: '食品',
//            index: '首页banner',
//            endTime: '2017-6-6',
//            status: '未送审',
//            createUser: 'admin',
//            createTime: '2017-11-11 10:00'
//          }
        ],
        // 条件筛选表单
        searchForm: {}
      }
    },
    computed: {
    },
    mounted(){      
      var that = this
      that.fetchData(true)
      that.fetchTypeList()
    },
    methods:{
      dateFormat2 (date) {
        return mm(date).format('YYYY-MM-DD')
      },
      dateFormat (row, column) {
        var date = row[column.property]
        if (date === undefined) {
          return ''
        }
        return mm(date).format('YYYY-MM-DD')
      },
    	// 提交审核结果
      sbIsAble () {
        var that = this

      	var data = {
          ad_id: that.editorForm['adId'],
          ad_status: 2,
          refuse_reason: ''
        }

        if (that.isAble === '0') {
        	if (!that.refuse_reason || that.refuse_reason === "" ) {
            that.$message.error(this.$t('mao_global.tip.groundsForRefusal'))
            return false
          }

          data['refuse_reason'] = that.refuse_reason
          data['ad_status'] = 3
        }

        axios.post(`${baseurl}/admanage/examine.do`,data).then(res=>{
        	that.$message(this.$t('app_vlsuccess'))
          that.fetchData()
          that.dialogFormVisible = false
          that.$router.push({path: '/examine-list'})
        })
      },
      jump (url) {
      	var that = this

        that.$router.push({path: url})
      },
    	// 行记录点击
      cellClick (v,url) {
        var that = this
      	if (url) {
        	that.$router.push({path: '/examine-list/' + v.adId})
//          axios.post(`${baseurl}/advertisement/detail.do`,{'id':v.adId}).then(res=>{
//            that.editorForm = res.data.data;
//            console.log(JSON.stringify(that.editorForm))
//            that.dialogFormVisible = true
//          })
        }
      },
      fetchTypeList () {
        var that = this
        axios.post(`${baseurl}/adType/list.do`,{'page':1, rows: 10000}).then(res=>{
          that.adTypeList = res.data.data
          that.loading = false
        })
      },
      handleSizeChange () {},
      handleCurrentChange () {},
      handleSelectionChange () {},
      // 分页查询触发
      pagingFetch () {

      },
      // 条件查询触发
      searchFetch () {

      },
      initFilterParams () {
        var that = this
        that.filterParam = {page: 1, rows: 20,ad_title: '',ad_type: '',distributorId: localStorage.getItem('mechanismId'),ad_position: '', ad_status: '1'}
        return that.filterParam;
      },
      // 记录详情
      recordDetail () {
      	var that = this
        axios.post(`${baseurl}/advertisement/detail.do`,{'id':that.sForm.ad_id}).then(res=>{
          var obj = res.data.data;
          that.sForm = {
            ad_id: obj['adId'],
            ad_imgUrl: obj['adImgurl'],
            ad_title: obj['adTitle'], // 广告标题
            ad_type: obj['adType'], // 广告类型
            ad_url: obj['adUrl'], // 跳转链接
            ad_Urltype: obj['adUrltype'],
            ad_start_date: obj['adStartDate'], // 开始时间
            ad_start_end: obj['adStartEnd'], // 结束时间
            ad_content: obj['adContent'], // 广告内容
            ad_position: obj['adPosition'], // 广告位置: 0 首页banner 1 启动界面 2个人中心
            ad_playTimes: obj['adPlayTimes']|| '' // 播放时长
          }
        })
      },
      // 初始化数据
      fetchData (bool) {

        var that = this

        // 是否第一次初始化
        if (bool) that.initFilterParams()


        axios.post(`${baseurl}/admanage/list.do`,that.filterParam).then(res=>{
          if (res.data && res.data.status && res.data.status === 200) {
            that.resultData = res.data.data
            // 获取当前条件查询下, 一共有多少条数据
            if (res.data.total) that.pagingData['total'] = res.data.total
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// examine.vue?06c60e96